











































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// The base for every input component
import InputBase from './Base.vue';

@Component
export default class InputRadio extends InputBase<string> {

    @Prop({ type: Object, required: true })
    private options!: { [guid: string]: Record<string, string>; };

    @Prop({ type: String, required: true })
    private labelKey!: string;

    /**
     *  Used to select a radio option, if not
     *  disabled or already selected.
     */
    private select(guid: string): void {

        if (this.disabled || this.newValue === guid) {

            return;

        }

        this.onInput(guid);

    }

}
